import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
export function ProgressBar() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 220,
    damping: 34,
    restDelta: 0.001
  });
  return <div className="fixed inset-x-0 top-0 z-50 h-1.5 bg-black" role="presentation" aria-hidden="true" data-id="element-169" data-mp="itpbgp437d0j">
      <motion.div style={{
      scaleX
    }} className="h-full origin-left bg-safety" data-id="element-170" data-mp="1ampsm8rykiom" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-white/70" data-id="element-171" data-mp="16lnujv9s2co8" />
    </div>;
}